// extracted by mini-css-extract-plugin
export default {"header":"index_header__8MtGr","cont":"index_cont__F4VG2","but":"index_but__EjOB6"};